import { MerchantMenuDto } from './merchant-menu.dto';
import { MerchantDto } from './merchant.dto';

export class NavigateToRequestDto {
  merchant: MerchantDto;
  menus: MerchantMenuDto[]
}
